import { FC, ReactNode } from "react";
import { motion } from "framer-motion";

interface Props {
  children: ReactNode;
}

const ContractUpdateLayout: FC<Props> = ({ children }) => {
  return (
    <div className="bg-gray-50 flex justify-center px-4">
      <motion.div
        className="w-full max-w-[756px] min-h-screen bg-white px-6 py-10 sm:px-16 shadow-xl flex flex-col"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 220, damping: 24 }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default ContractUpdateLayout;
